import type { SVGProps } from 'react';
export const SvgShare = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
		fill="none"
		viewBox="0 0 20 20"
		{...props}
	>
		<path
			stroke="#fff"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="m6.167 5.267 7.075-2.359c3.175-1.058 4.9.675 3.85 3.85l-2.359 7.076c-1.583 4.758-4.183 4.758-5.766 0l-.7-2.1-2.1-.7c-4.759-1.584-4.759-4.176 0-5.767M8.425 11.375l2.983-2.992"
		/>
	</svg>
);
